// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import greifReducer, { GreifActions } from "@store/Framework/Store/Greif/GreifReducer";
import "@toolkit/Framework/Store";

export type GreifAnyAction = GreifActions;
(reducers as any).greif = greifReducer;
